import React from 'react';
import { LiliRadioChipProps } from './LiliRadioChip';
import { ReactComponent as CheckIcon } from '../../assets/icons/svg/shared/ic-shared-checkmark.svg';

export const LiliRadio = (props: LiliRadioChipProps<any>) => {
  const { radioGroupId, onClick, checked, value, label } = props;

  const getCheckedStyle = () => {
    if (checked) {
      return 'bg-action03 border border-action03';
    }
    return 'bg-bw01 border border-bw06 hover:border-action03';
  };

  return (
    <button
      onClick={() => onClick && onClick(value)}
      type='button'
      className='w-fit transition ease-in flex items-center justify-center gap-[6px] rounded-[33px] cursor-pointer'
    >
      <div className='relative flex flex-col items-center'>
        <input
          className={`${getCheckedStyle()} w-[18px] h-[18px] transition ease-in rounded-[50%] appearance-none cursor-pointer`}
          type='radio'
          name={radioGroupId}
          checked={checked}
          value={value}
          id={value.toString()}
          onClick={() => onClick && onClick(value)}
        />
        <CheckIcon className='pointer-events-none stroke-bw01 w-[90%] text-bw01 absolute left-1/2 -translate-x-1/2 -top-1/2 translate-y-[calc(50%-8%)]' />
      </div>

      {label && (
        <label
          className='font-metricRMedium pointer-events-none text-[16px] leading-[24px] text-bw07'
          htmlFor={value.toString()}
        >
          {label}
        </label>
      )}
    </button>
  );
};
